module.exports = __webpack_public_path__ + "assets/img/rule-back.2c2efd9a.png";